import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '~/core/classes/auth/auth.guard';

//******************************************************************************
//  App Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { DashboardComponent } from '~/pages/dashboard/dashboard.component';

export const routes: any[] = [
    {
        path: '',
        title: 'Notification Agent',
        icon: 'campaign',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'dashboard',
        title: 'Dashboard',
        icon: 'dashboard',
        isNav: false,
        component: DashboardComponent,
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: 'notfound',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRouting { }
